<hierarchy
  #hierarchy
  [currentItem]="currentItem"
  [subordinateItems]="subordinateItems"
  [superiorItems]="superiorItems"
  (selectedItem)="onSelectedItemToPopUp($event)"
  (openSubordinateItemsList)="openEmployeeList()"
  [isPopUp]="size === 'popup'"
  [focusedElementId]="elementsList[markedIndex]?.id"
  [selectedElement]="selectedElement"
  (componentFocusedExit)="componentFocusedExit.emit($event)"
  (onOpenSuperiorItems)="openSuperiorItems = true"
  [smallWidthPreview]="smallWidthPreview"
  [previewPopupLarge]="previewPopupLarge"
></hierarchy>
